import { signInWithEmailAndPassword, signOut, onAuthStateChanged, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

// Admin email (only this email can access admin features)
const ADMIN_EMAIL = 'btwpune@gmail.com';

// Sign in admin
export const signInAdmin = async (email, password) => {
  try {
    if (email !== ADMIN_EMAIL) {
      throw new Error('Unauthorized: Only admin can access this area');
    }
    
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    console.error('Error signing in:', error);
    throw error;
  }
};

// Sign out admin
export const signOutAdmin = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};

// Send password reset email (only for admin email)
export const sendPasswordReset = async (email) => {
  try {
    if (email !== ADMIN_EMAIL) {
      throw new Error('Password reset is only available for admin account');
    }
    
    await sendPasswordResetEmail(auth, email);
    return { success: true, message: 'Password reset email sent successfully' };
  } catch (error) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};

// Check if current user is admin
export const isAdmin = (user) => {
  return user && user.email === ADMIN_EMAIL;
};

// Listen to auth state changes
export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Get current user
export const getCurrentUser = () => {
  return auth.currentUser;
};